exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-yellow{color:#fcdb01}.is-blue{color:#47c0e7}.is-red{color:#9f232b}.active{color:#f6f8f7}.intro{margin-top:30px;margin-bottom:25px;padding-left:2%;line-height:1;justify-content:center}@media screen and (max-width:39.9375em){.intro{text-align:center}}@media print,screen and (min-width:40em){.intro{padding-left:50px}}@media screen and (min-width:48em){.intro{padding-left:12px;justify-content:flex-start}}.intro h1{margin-bottom:10px;font-size:36px;color:#fcdb01;line-height:1}@media print,screen and (min-width:40em){.intro h1{font-size:50px}}.intro p{font-size:20px;line-height:1.33}@media print,screen and (min-width:40em){.intro p{font-size:24px}}.intro .shadow{color:#bec0c2}.intro .highlight{color:#f6f8f7}.logo-links{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33c719d3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Intro.vue
// module id = 377
// module chunks = 0